import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { CareersForm } from "@/components/forms/CareersForm";
import { absoluteUrl } from "@/lib/absolute-url";

const TITLE = "RESTORE Hair Careers: Open Job Opportunities";
const DESCRIPTION =
  "Check out our current RESTORE Hair Careers page. Search current job openings at RESTORE, and apply today.";
const AWARD_IMAGE = "/img/r/wp-2022-03-image-51-1.webp";
const HERO_IMAGE = "/img/r/wp-2022-04-career-banner.webp";
const URL = "https://restorehair.com/careers/";

export const Route = createFileRoute("/careers")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { property: "og:url", content: URL },
      { property: "og:image", content: absoluteUrl(AWARD_IMAGE) },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: absoluteUrl(AWARD_IMAGE) },
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: CareersPage,
});

function CareersPage() {
  return (
    <div className="min-h-screen bg-background font-sans">
      <Header />
      <main>
        <section className="bg-muted/40">
          <img
            src={HERO_IMAGE}
            alt="RESTORE Hair careers team banner"
            className="h-auto w-full object-cover"
          />
        </section>

        <section className="bg-muted/40 py-10 md:py-14">
          <div className="mx-auto max-w-4xl px-4 text-center lg:px-8">
            <h1 className="text-sm font-semibold uppercase tracking-widest text-primary">
              RESTORE® Hair Careers
            </h1>
            <h2 className="mt-3 text-3xl font-extrabold tracking-tight text-foreground md:text-5xl">
              Start Your Career at RESTORE® Today
            </h2>
          </div>
        </section>

        <section className="py-10 md:py-14">
          <div className="mx-auto max-w-4xl px-4 lg:px-8">
            <p className="text-base leading-relaxed text-muted-foreground md:text-lg">
              At RESTORE® Hair, we believe in more than just hair restoration; we believe in
              transforming lives. Our mission is to empower individuals by providing exceptional
              care and cutting-edge solutions in a supportive and innovative environment. We're
              committed to fostering a culture that values collaboration, creativity, and
              personal growth.
            </p>

            <p className="mt-6 text-base leading-relaxed text-muted-foreground md:text-lg">
              RESTORE Hair is an award-winning company that has been praised as one of DuPage
              County's "Smartest, Sleekest, and Healthiest Workplaces in 2021"
            </p>

            <img
              src={AWARD_IMAGE}
              alt="RESTORE Hair named one of DuPage County's smartest, sleekest and healthiest workplaces in 2021"
              loading="lazy"
              className="mx-auto mt-10 h-auto w-full max-w-[160px] md:max-w-[190px]"
            />

            <p className="mt-10 text-center text-base leading-relaxed text-muted-foreground md:text-lg">
              If you're ready to make a difference and be part of something truly special, we
              invite you to apply. Together, let's redefine the hair restoration experience and
              create lasting impact in our clients' lives.
            </p>
          </div>
        </section>

        <section className="bg-muted/40 py-10 md:py-16">
          <div className="mx-auto max-w-3xl px-4 lg:px-8">
            <h2 className="text-center text-2xl font-bold tracking-tight text-foreground md:text-3xl">
              Have Other Career Questions?
            </h2>
            <div className="mt-8 rounded-lg border border-border bg-card p-6 shadow-sm md:p-8">
              <CareersForm />
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}